import React from 'react';
import type { Nullable } from 'corgi-types';
import type { SpaceProps, WidthProps } from 'styled-system';

import { openPaymentMethodSelectionDrawer } from '../../../payment-method-selection/components/PaymentMethodCardWithDrawer/utils';
import { PAYMENT_NOT_SET_IN_CONFIRM_STEP_ERROR } from '../../constants/checkout';
import AutoScrollAlert from '../AutoScrollAlert';
import { useCheckoutErrorMessage } from './hooks/use-checkout-error-message';

interface CheckoutAlertListenerProps extends SpaceProps, WidthProps {
  initialErrorDetail: Nullable<string>;
  scrollOnError: boolean;
}

const getPropsForIntialError = (errorDetail: Nullable<string>) => {
  switch (errorDetail) {
    case PAYMENT_NOT_SET_IN_CONFIRM_STEP_ERROR:
      return {
        onClick: openPaymentMethodSelectionDrawer,
        scrollOnError: false,
      };

    default:
      return null;
  }
};

const CheckoutAlertListener = ({
  initialErrorDetail,
  scrollOnError,
  ...styleProps
}: CheckoutAlertListenerProps) => {
  const { message, timestamp, isInitialError } = useCheckoutErrorMessage(initialErrorDetail);

  const propsForInitialError = isInitialError ? getPropsForIntialError(initialErrorDetail) : null;

  return message ? (
    <AutoScrollAlert
      trackImpression={true}
      message={message}
      scrollOnError={scrollOnError}
      messageId={timestamp}
      {...propsForInitialError}
      {...styleProps}
    />
  ) : null;
};

export default CheckoutAlertListener;
